import { useState, useEffect, useRef } from "react";
import {  Loader } from "./index";
import { useNavigate } from "react-router-dom";
import { defaultSrc } from "../utils/Helpers";
import audio from "../assets/icons/test_voice.png";
import test from "../assets/icons/call_test_botton.png";
import stop from "../assets/TestStop.png";
import waveGif from "../assets/medium.gif";
import { SendGuiDataEvents } from "../commonScript";

const Ambience = ({ data,loading, setLoading }) => {
  const [showModel, setShowModel] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState();
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleClick = (item, index) => {
    let guiPlayEvents = {};
    guiPlayEvents["w_action"] = "card_click";
    guiPlayEvents["name"] = item.name;
    guiPlayEvents["clicked_uid"] = item.uid;
    guiPlayEvents["type"] = item.type;
    guiPlayEvents["short_code"] = item.short_code;
    SendGuiDataEvents(guiPlayEvents);
    console.log("The clicked item is::", item);
    localStorage.setItem("currentSelectedAvatar", JSON.stringify(item));
    const status = localStorage.getItem("status");
   
    if (status && status.toLowerCase() === "active") {
      navigate("/calls");
    } else {
      console.log("not active user");
      navigate("/calls")
    }
  };
  const handleCallClick = () => {
    console.log("call button clicked");
    navigate("/calls");
  };
  const handlePlayPauseClick = () => {
    console.log("The audioRef is:::", audioRef.current);
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  if (loading) return <Loader />;
  return (
    <div className="pt-[7.5rem] grid grid-cols-2  z-0  mx-1 h-full pb-2 gap-y-2  ">
      {data &&
        data.map((item, i) => {
          return (
            <div
              key={i}
              className="p-4 text-center flex flex-col justify-center items-center cursor-pointer fadeInOut card-shadow mx-1 rounded-md h-full "
              onClick={() => handleClick(item, i)}
            >
              <img
                src={item.image_url ? item.image_url : defaultSrc()}
                alt={item.name}
                className={`-z-0 h-34`}
                lazy="loading"
                height="150px"
                width="150px"
              />
              <p className="grey-theme-color mt-3 capitalize font-bold">
                {item.name}
              </p>
            </div>
          );
        })}
      {selectedAvatar && (
        <div
          className={`${
            showModel
              ? "fixed top-0 w-full bg-model  overflow-y-hidden  py-6"
              : ""
          }`}
        >
          {selectedAvatar && (
            <div className={` rounded-lg overflow-y-hidden  `}>
              <audio ref={audioRef} src={selectedAvatar.fileSource}></audio>
              <div
                onClick={() => {
                  if (isPlaying) {
                    handlePlayPauseClick();
                  }
                  setShowModel(false);
                }}
                className="font-bold text-xl text-white text-center p-3 cursor-pointer"
              >
                X
              </div>
              <div className="absolute top-[60%] left-1/2 -translate-x-1/2">
                <div className="flex flex-col justify-center items-center">
                  <img
                    src={
                      selectedAvatar.image_url
                        ? selectedAvatar.image_url
                        : defaultSrc()
                    }
                    alt={selectedAvatar.name}
                  />
                  <p className="text-white">{selectedAvatar.name}</p>
                </div>

                <div className="flex w-full p-4 justify-center items-center ">
                  {!isPlaying ? (
                    <div
                      className="w-1/3 ml-1 mr-6"
                      onClick={() => handlePlayPauseClick()}
                    >
                      <img
                        src={audio}
                        alt="call"
                        className="m-auto cursor-pointer"
                      />
                    </div>
                  ) : (
                    <div
                      className="w-1/3 ml-1 mr-6"
                      onClick={() => handlePlayPauseClick()}
                    >
                      <img
                        src={stop}
                        alt="call"
                        className="m-auto cursor-pointer"
                      />
                    </div>
                  )}
                  {!isPlaying ? (
                    <div
                      className="w-1/3 ml-6 mr-1"
                      onClick={() => handleCallClick()}
                    >
                      <img
                        src={test}
                        alt="audio"
                        className="m-auto cursor-pointer"
                      />
                    </div>
                  ) : (
                    <div className="w-1/3 ml-6 mr-1">
                      <img
                        src={waveGif}
                        alt="audio"
                        className="m-auto cursor-pointer"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Ambience;
